import axios from "axios";
import { ClearSession, GetSession } from "../../Shared-ui/utils/Auth/AuthHelpers";
import { BaseUrl } from "../../Constant/Setting";
import { ShowError } from "../../Shared-ui/Store/MessageReducer/MsgActions";
import Store from "../../Shared-ui/Store";

const BaseInstance = axios.create({
    baseURL: BaseUrl,
    headers: {
        'Content-Type': 'application/json',
    }
})

// Set up an Axios request interceptor to add the authorization token

BaseInstance.interceptors.request.use((config) => {
    const serviceToken = GetSession()
    if (serviceToken) {
        config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// Set up an Axios response interceptor to handle authentication errors and logout

BaseInstance.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response) {
        // return Promise.reject(error)
        if (error.response.status === 401 || error.response.status === 403) {
            ClearSession()
            window.location.href = "/logout"
        }
        else if (error.response.status === 405) {
            sessionStorage.setItem("errorStatusCode", "405")
            window.location.href = "/userprofile"
        }
        else if (error.response.status === 400) {
            Store.dispatch(ShowError(error?.response?.data?.detail, 3000))
        } else {
            return Promise.reject(error)
        }
    }
    return Promise.reject(error)
})

export default BaseInstance